import { Flex, Typography } from 'antd';
import dayjs from 'dayjs';

import styles from './ListUpsertByRenderer.module.scss';

export default function ListUpsertByRenderer({
  ownerName,
  record,
  dateProperty,
} : {
  ownerName: string;
  record: any;
  dateProperty: string;
}) {
  return (
    <Flex vertical>
      <Typography.Text>
        {ownerName}
      </Typography.Text>
      <Typography.Text className={styles.upsertDate}>
        {dayjs(record[dateProperty]).format('DD/MM/YYYY HH:mm A')}
      </Typography.Text>
    </Flex>
  );
}
